import React, { useEffect, useState, useRef } from 'react'
import * as THREE from 'three';
import { useLoader, useThree } from 'react-three-fiber'
import { OrbitControls } from 'drei'
import { EffectComposer, Bloom, Noise } from '@react-three/postprocessing'
import { isMobile, isSafari } from 'react-device-detect'
import { IS_PRODUCTION } from '../../config'
import useStore from '../../store'

const Environment = ({ children }) => {
  const orbit = useRef()
  const orbitEnabled = useStore((state) => state.orbit.enabled)
  const { gl, scene, camera } = useThree()
  const [ready, setReady] = useState(false)
  const texture = useLoader(THREE.TextureLoader, '/assets/images/hdri.jpg')

  useEffect(() => {
    if (orbit.current) {
      camera.position.set(3.30, 4.73, 4.30)
      camera.rotation.set(-0.83, 0.48, 0.47)
      orbit.current.update()
    }
  }, [camera, orbit])

  useEffect(() => {
    if (orbit.current) {
      if (orbit.current.enabled !== orbitEnabled) {
        orbit.current.enabled = orbitEnabled
        orbit.current.update()
      }
    }

    // console.log({ position: camera.position, rotation: camera.rotation })
  }, [orbit, orbitEnabled])

  useEffect(() => {
    if (!texture) return

    texture.encoding = THREE.sRGBEncoding;
    texture.mapping = THREE.EquirectangularReflectionMapping;
    scene.background = texture
    setReady(true)
  }, [scene, texture])

  return (
    <>
      <OrbitControls
        ref={orbit}
        rotateSpeed={0.3}
        autoRotate={IS_PRODUCTION}
        autoRotateSpeed={0.5}
        zoomSpeed={0.5}
        // dampingFactor={}
        // enableDamping
        enablePan={false}
        minDistance={0}
        maxDistance={70}
      />
      <ambientLight intensity={3} />
      {/* <spotLight intensity={0.1} position={[0, 10, 0]} /> */}
      <hemisphereLight position={[0, 4, 0]} />

      {ready && children}
      {(!isMobile || !isSafari) && (
        <EffectComposer args={[gl]} >
          <Bloom luminanceThreshold={0} luminanceSmoothing={1.5} height={500} />
          <Noise opacity={0.01} />
        </EffectComposer>
      )}
    </>
  )
}

export default Environment
